var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 312.04 311.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2-2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.73,170.53l-20.3,22.74-66.87-60.68c-15.59-13.85-38.6-15.39-55.41-2.86L0,165.62.05,59.22C.07,26.3,27.24,0,60.07,0h191.81c32.8,0,60,26.29,60.01,59.25l.07,154.5-60.56-48.3c-18.42-14.69-44.74-12.67-60.67,5.07ZM110.94,44.53c-13.76,2.95-21.41,16.33-18.18,29.28,3.07,12.31,15.66,20.17,28.23,17.47,12.85-2.76,21.12-15.43,18.49-28.11s-14.95-21.55-28.53-18.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M253.8,311.13l-156.36.21,111.07-124.76c7.14-7.98,18.98-9.51,27.48-2.73l75.69,60.4c3.8,34.32-22.01,66.83-57.87,66.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.49,311.15C30.98,314.31.06,287.4.04,252.18L0,195.59l61.72-46.19c7.99-5.97,18.51-5.6,25.97,1.17l66.8,60.62-89.01,99.96Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.909d409bc7106e87e6671ceeb94ff727.svg";
export { ForwardRef as ReactComponent };